<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/5chap1#chap1"><i>Stories</i></a></p>
<p class="toc2"><a href="#/6chap2#chap2">Home Movie</a></p>
<p class="toc2"><a href="#/7chap3#chap3">The Day I Don’t Remember</a></p>
<p class="toc2"><a href="#/8chap4#chap4">The Puppet Show</a></p>
<p class="toc2"><span href="#/9chap5#chap5" title="Link target outside of Sample">Outlander</span></p>
<p class="toc2"><span href="#/10chap6#chap6" title="Link target outside of Sample">Miss Wistan’s Promise</span></p>
<p class="toc2"><span href="#/11chap7#chap7" title="Link target outside of Sample">Pictures</span></p>
<p class="toc2"><span href="#/12chap8#chap8" title="Link target outside of Sample">The Killer Dyke and the Lady</span></p>
<p class="toc2"><span href="#/13chap9#chap9" title="Link target outside of Sample">Lilian</span></p>
<p class="toc2"><span href="#/14chap10#chap10" title="Link target outside of Sample">In the Attic of the House</span></p>
<p class="toc2"><span href="#/15chap11#chap11" title="Link target outside of Sample">First Love/Last Love</span></p>
<p class="toc2"><span href="#/16chap12#chap12" title="Link target outside of Sample">Sightseers in Death Valley</span></p>
<p class="toc2"><span href="#/17chap13#chap13" title="Link target outside of Sample">A Perfectly Nice Man</span></p>
<p class="toc2"><span href="#/18chap14#chap14" title="Link target outside of Sample">Night Call</span></p>
<p class="toc1" style="margin-top:20px;"><span href="#/19chap15#chap15" title="Link target outside of Sample"><i>Essays</i></span></p>
<p class="toc2"><span href="#/20chap16#chap16" title="Link target outside of Sample">Sexuality in Literature</span></p>
<p class="toc2"><span href="#/21chap17#chap17" title="Link target outside of Sample">Teaching Sexuality</span></p>
<p class="toc2"><span href="#/22chap18#chap18" title="Link target outside of Sample">Private Parts and Public Figures</span></p>
<p class="toc2"><span href="#/23chap19#chap19" title="Link target outside of Sample">With All Due Respect</span></p>
<p class="toc2"><span href="#/24chap20#chap20" title="Link target outside of Sample">Homophobia and Romantic Love</span></p>
<p class="toc2"><span href="#/25chap21#chap21" title="Link target outside of Sample">Stumps</span></p>
<p class="toc2"><span href="#/26chap22#chap22" title="Link target outside of Sample">Letters</span></p>
<p class="toc2"><span href="#/27chap23#chap23" title="Link target outside of Sample">The Sex War</span></p>
<p class="toc2"><span href="#/28chap24#chap24" title="Link target outside of Sample">Fucking Pariahs on the Schoolroom Shelf</span></p>
<p class="toc2"><span href="#/29chap25#chap25" title="Link target outside of Sample">Closet-Burning</span></p>
<p class="toc2"><span href="#/30chap26#chap26" title="Link target outside of Sample">Reflections</span></p>
<p class="toc2"><span href="#/31chap27#chap27" title="Link target outside of Sample">Grandmothers</span></p>
<p class="toc1"><span href="#/32biography#biography" title="Link target outside of Sample">A Biography of Jane Rule</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4TOC.vue?3320b7b2